module.exports = __webpack_public_path__ + "static/CSF5-59db2650100cea47e47cd87a906c2f2e.png";